var locale = {
  lang: {
    locale: 'zh_CN',
    now: '此刻',
    ok: '确定',
    timeSelect: '选择时间',
    clear: '清除'
  },
  timePickerLocale: {
    placeholder: '请选择时间',
    rangePlaceholder: ['开始时间', '结束时间']
  }
};
export default locale;